import { HashTable } from "@/utils/HashTable";
import { VeicleLastGps } from "./vehicleLastGps";

function VeicleLastGpsList() {

    this.map;

    this.vehicleList = new HashTable();


    this.init = (map) => {
        this.map = map;
    }
    this.updateGps = (info) => {
        if (info && info.VehicleID) {
            var k = this.vehicleList.items(info.VehicleID);
            if (k)
                k.updateGps(info)
        }
    }
    this.updateVehicles = (vehicles) => {
        vehicles.forEach(v => {

            if (v.treeLevel == 5) {
                //不存在，新建，标志位，不销毁
                if (this.vehicleList.contains(v.nodeValue)) {

                    var k = this.vehicleList.items(v.nodeValue);
                    k.updateDestroyFlag(0)
                    // this.vehicleList.update(vid,k);

                } else {
                    var t = new VeicleLastGps();
                    t.init(this.map, v)
                    this.vehicleList.add(v.nodeValue, t);
                }
            }
            //存在，更新标志位，不销毁
        });

        //循环车辆列表，判断标志位，如果没有不销毁的，进行销毁，把原来不销毁标志进行切换
        this.vehicleList.keys(v => {

            var k = this.vehicleList.items(v);
            if (k.destroyFlag == 1) {
                k.destroy();
                this.vehicleList.remove(v);
            }
            else {
                k.updateDestroyFlag(1);
                // this.vehicleList.update(v,k);
            }

        });

    }



}

export { VeicleLastGpsList };